import React from 'react'
import { CheckCircleSecond } from 'src/components/Icons/CheckCircleSecond'
import { Image } from 'src/components/ui/Image'

interface BenefitItem {
  text: string
}

interface InsuranceSectionBannerGridProps {
  imageDesktop: string
  imageMobile?: string
  benefits: BenefitItem[]
}

const InsuranceSectionBannerGrid: React.FC<InsuranceSectionBannerGridProps> = ({
  imageDesktop,
  imageMobile,
  benefits,
}) => {
  return (
    <section className="w-full max-w-[1142px] mx-auto md:mt-12 mb-14 md:mb-24">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="relative overflow-hidden min-h-[320px] flex items-end">
          <Image
            src={imageMobile ?? imageDesktop}
            srcSet={
              imageDesktop
                ? `${imageMobile ?? imageDesktop} 767w, ${imageDesktop} 768w`
                : undefined
            }
            alt="Banner Seguro Bike"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 px-5 md:px-0">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="bg-white border border-[#D9DDE1] p-6 flex flex-col gap-2 items-start min-h-[120px]"
            >
              <span className="mt-1 h-8 w-8">
                <CheckCircleSecond />
              </span>
              <span className="text-[#101010] text-base font-semibold leading-7">
                {benefit.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default InsuranceSectionBannerGrid
